import React from "react"
export const TransshipmentDetailContext = React.createContext(null);

export const useTransshipmentDetailContext = () => {

    const context = React.useContext(TransshipmentDetailContext);

if (!context) throw new Error("Transhipment Detail Context not provided!");

return context;
}